import * as ng from 'angular';

export const NgDblClick = () => (<angular.IDirective>{

    restrict: 'A',

    link: (scope: any, element: JQLite, attrs: any) => {

        let isSingleClick = true;
        let delay = 500;

        element.bind('dblclick', () => {
            isSingleClick = false;
            setTimeout(() => {
                isSingleClick = true;
                return;
            }, delay);
        });
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/ng-dbl-click/ng-dbl-click.directive.ts